import {Component, Input, OnInit} from '@angular/core';
import {BlacklistRemarkModel} from '../../../../shared/dto/blacklist-remark.model';

@Component({
  selector: 'app-remark-history',
  templateUrl: './remark-history.component.html',
  styleUrls: ['./remark-history.component.scss']
})
export class RemarkHistoryComponent implements OnInit {
  @Input() data: BlacklistRemarkModel[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;
  public remarkHistory: BlacklistRemarkModel[] = [];
  constructor() { }

  ngOnInit() {

  }

}
